export const isLoggedIn = () => {
    if(localStorage.hasOwnProperty('auth')) {
        return true;
    } else {
        return false;
    }
}